import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { Button } from '../../ui/Button';

/**
 * Główna akcja modułu pod kciukiem na telefonie (DECISIONS 2026-10-17 [P] „Telefon…”: „główna akcja zawsze pod
 * kciukiem”; ten sam wzorzec co „Nowe zadanie” w Zadaniach): pływający przycisk Primary nad dolnym menu, po lewej
 * (po prawej jest bąbel Copilota). Tylko < 768 px — na desktopie główna akcja zostaje w nagłówku strony (tam schowaj
 * ją na telefonie klasą `max-md:hidden`, żeby był najwyżej jeden Primary). `AppShell` rezerwuje miejsce pod treścią
 * (pb 136 px), więc przycisk nie zasłania ostatniego wiersza listy.
 */
export function MobileFab({
  icon,
  onClick,
  children,
  className,
  'aria-label': ariaLabel,
}: {
  icon: LucideIcon;
  onClick: () => void;
  children: ReactNode;
  className?: string;
  'aria-label'?: string;
}) {
  return (
    <Button
      variant="primary"
      size="l"
      icon={icon}
      onClick={onClick}
      aria-label={ariaLabel}
      data-mobile-fab=""
      className={cn(
        'fixed bottom-[calc(76px+env(safe-area-inset-bottom)+12px)] left-4 z-30 h-12 rounded-full px-5 shadow-modal md:hidden',
        className,
      )}
    >
      {children}
    </Button>
  );
}
